export default {
  lensSelector: {
    height: '580px',
    maxHeight: 'calc(80vh - 70px)',
    display: 'flex',
    flexDirection: 'column'
  },
  columnWrapper: {
    flex: '1 1 auto',
    minHeight: 0,
    display: 'flex'
  },
  checkWrapper: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginTop: '1rem',
    fontWeight: '400',
    '& span': {
      marginRight: '.5rem'
    }
  }
}


// WEBPACK FOOTER //
// ./src/components/LensModelSelector/style.js